module.exports = __webpack_public_path__ + "static/media/85.7968da39.jpg";